'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

/**
 * PostHog - The Product OS. Unified platform for:
 * 1. Session Replay (High fidelity)
 * 2. Analytics (Umami/GA4 level data)
 * 3. Heatmaps
 * 4. Feature Flags
 */
export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return <PHProvider client={posthog}>{children}</PHProvider>;
}
